import React, { useState, useEffect } from 'react';
import styled from 'styled-components';
import heartImage from '../../assets/heartImage.png';
import data from './data';

const width = window.innerWidth;
export default function PaginatiedSection() {
 const [reviews] = useState(data);
 const [value, setValue] = useState(1);

 //implemtation of slider using useEffect hook
 useEffect(() => {
  const size = reviews.length - 1;
  if (value < 0) setValue(size);
  if (value > size) setValue(0);
 }, [value, reviews]);
 useEffect(() => {
  const slider = setTimeout(() => {
   setValue(value + 1);
  }, 5000);
  return () => clearInterval(slider);
 }, [value]);
 return (
  <Paginationsection>
   <div className='header'>
    <Heading>Latest news on EPR</Heading>
    <Linebreak>
     <div className='part1'></div>
     <div className='part2'></div>
     <div className='part3'></div>
    </Linebreak>
   </div>
   <section className='section'>
    <div className='section-center'>
     {reviews.map((element, index) => {
      let position = 'nextSlide';
      if (value === index) position = 'activeSlide';
      if (width > 600 && value === (index + 1) % reviews.length)
       position = 'activeSlideleft';
      if (
       width > 600 &&
       value === (index - 1 + reviews.length) % reviews.length
      )
       position = 'activeSlideright';

      if (
       width <= 600 &&
       value === (index - 1 + reviews.length) % reviews.length
      )
       position = 'lastSlide';

      if (
       width > 600 &&
       (index - 2 + reviews.length) % reviews.length === index
      )
       position = 'lastSlide';
      return (
       <Card className={position} id={index} data={element} extras={position} />
      );
     })}
    </div>
   </section>
  </Paginationsection>
 );
}

function Card({ data, extras }) {
 return (
  <Cardcontainer className={extras}>
   <Imagecontainer src={data.image} alt='card image' />
   <Content>
    <Header>{data.desc}</Header>
    <Actionbutton>
     <div>
      <Icon src={data.icon} alt='Icon' />
      {data.handle}
     </div>
     <Icon src={heartImage} alt='heart icon' />
    </Actionbutton>
    <Readmorebutton>Continue Reading</Readmorebutton>
   </Content>
  </Cardcontainer>
 );
}

const Paginationsection = styled.div`
 width: 100%;
 margin-top: 5rem;
 .header {
  width: fit-content;
 }

 .section {
  width: 100%;
  margin: 5rem auto;
  max-width: var(--max-width);
 }

 .section-center {
  width: 100%;
  /* have to have a height */
  height: 40rem;
  text-align: center;
  position: relative;
  display: flex;
  flex-wrap: nowrap;
  overflow: hidden;
  gap: 1rem;
 }

 .prev,
 .next {
  position: absolute;
  top: 200px;
  transform: translateY(-50%);
  background: var(--clr-grey-5);
  color: var(--clr-white);
  width: 1.25rem;
  height: 1.25rem;
  display: grid;
  place-items: center;
  border-color: transparent;
  font-size: 1rem;
  border-radius: var(--radius);
  cursor: pointer;
  transition: var(--transition);
 }

 .prev:hover,
 .next:hover {
  background: var(--clr-primary-5);
 }

 .prev {
  left: 0;
 }

 .next {
  right: 0;
 }

 @media (min-width: 800px) {
  .text {
   max-width: 45em;
  }
  .prev,
  .next {
   width: 2rem;
   height: 2rem;
   font-size: 1.5rem;
  }
 }

 article {
  position: absolute;
  top: 0;
  left: 50%;
  width: 30%;
  height: 100%;
  opacity: 0;
  transition: all 0.3s linear;
  border-radius: 2rem;
  border: 2px solid #9b9b9b;
 }

 .activeSlide {
  opacity: 1;
  transform: translateX(-50%);
 }

 .activeSlideleft {
  opacity: 1;
  transform: translateX(-155%);
 }

 .activeSlideright {
  opacity: 1;
  transform: translateX(55%);
 }

 .lastSlide {
  transform: translateX(-300%);
 }

 .nextSlide {
  transform: translateX(300%);
 }
 @media screen and (max-width: 600px) {
  width: 90%;
  margin: 5rem auto 0 auto;
  article {
   width: 70%;
  }
  .lastSlide {
   transform: translateX(-160%);
   opacity: 1;
  }

  .nextSlide {
   transform: translateX(60%);
   opacity: 1;
  }
 }
`;

const Heading = styled.h1`
 font-size: 3.2rem;
 font-weight: 700;
 line-height: 7rem;
 /* font-family: 'Segoe UI'; */
 color: #404040;
`;

const Linebreak = styled.div`
 width: 50%;
 display: flex;
 gap: 0.5rem;
 margin-top: -1rem;
 div {
  background-color: #84d908;
  border-radius: 1rem;
  height: 0.5vh;
 }
 .part1 {
  width: 40%;
 }
 .part2 {
  width: 30%;
 }
 .part3 {
  width: 10%;
 }
`;

const Cardcontainer = styled.article`
 height: 40rem;
 display: flex;
 flex-direction: column;
`;
const Imagecontainer = styled.img`
 width: 100%;
 height: 20rem;
 object-fit: cover;
 border-radius: 2rem 2rem 0 0;
`;
const Icon = styled.img`
 width: 3rem;
 height: 3rem;
 object-fit: cover;
`;
const Content = styled.div`
 padding: 0 2rem;
 flex-grow: 1;
 display: flex;
 flex-direction: column;
 justify-content: space-evenly;
`;
const Header = styled.h3`
 font-size: 1.5rem;
 font-weight: 600;
 color: #645e58;
 line-height: 1.5rem;
 text-align: left;
`;
const Actionbutton = styled.div`
 div {
  display: flex;
  gap: 2rem;
  align-items: center;
  font-size: 1.4rem;
  color: #818181;
  font-weight: 600;
 }
 display: flex;
 justify-content: space-between;
`;
const Readmorebutton = styled.div`
 color: #90d62b;
 font-size: 1.5rem;
 font-weight: 600;
 text-align: left;
 cursor: pointer;
`;
